import InstantPlayer from './chromeless/instantplayer'
import ApiManager from './model/apimanager.js'
import DataObjs from './model/dataobjs.js'
var PlayInfoObj = DataObjs.PlayInfoObj
var MetaObj = DataObjs.MetaObj
var DataInfo = DataObjs.DataInfo

export default class ScalablePlayer {
    constructor (bodyEl, playerType, playerMode, cloudType) {
        if (ScalablePlayer.isNull(bodyEl)) {
            console.error('wavveplayer-constructor: Invalid parameter.')
            return null
        }
        this.parent = bodyEl
        if (ScalablePlayer.isNull(this.parent)) {
            return
        }
        while (this.parent.childNodes.length > 0) {
            this.parent.removeChild(this.parent.firstChild)
        }

        if (ScalablePlayer.isNull(playerType)) {
            playerType = ScalablePlayer.playerType.INSTANT
        }
        this.playerType = playerType

        if (ScalablePlayer.isNull(playerMode)) {
            playerMode = ScalablePlayer.playerMode.DEFAULT
        }
        this.playerMode = playerMode

        if (ScalablePlayer.isNull(cloudType)) {
            cloudType = ScalablePlayer.cloudType.AZURE
        }
        this.cloudType = cloudType

        this.apiManager = new ApiManager()
        this.playInfoObj = null
        this.metaObj = null

        this.dataInfo = new DataInfo()
        this.dataInfo.init()

        this.unloadedCallback = null
        this.errorCallback = null

        switch (playerType) {
            case ScalablePlayer.playerType.INSTANT:
                this.player = new InstantPlayer(this.parent, cloudType)
                break
            default:
                console.error('wavveplayer-constructor: Not support type. (type=' + playerType + ')')
                return null
        }

        this.player.init()
    }

    destructor () {
        if (!ScalablePlayer.isNull(this.player)) {
            this.parent.innerHTML = ''
            this.player.destructor()
            this.player = null
        }
    }

    load (contentType, contentID) {
        let isAutoPlay = false

        if (ScalablePlayer.isNull(contentType)) {
            contentType = ScalablePlayer.contentType.NONE
        }
        if (ScalablePlayer.isNull(contentID)) {
            console.error('wavveplayer-load: contentID is NULL')
            return null
        }
        if (ScalablePlayer.isNull(this.player)) {
            console.error('wavveplayer-load: player is NULL. You must call constructor.')
        }
        if (this.playerType === ScalablePlayer.playerType.INSTANT) {
            isAutoPlay = true
        }

        var that = this
        this.playInfoObj = new PlayInfoObj(contentType, contentID, this.playerMode)
        this.apiManager.getPlayInfo(this.playInfoObj, this.dataInfo).then(function (playInfoObj) {
            if (ScalablePlayer.isNull(that.player)) { // Already called destructor
                console.log('wavveplayer-load-getPlayerInfo: Player is null.')
                return
            }
            that.playInfoObj = playInfoObj
            that.player.load(playInfoObj, isAutoPlay)
        }, function (e) {
            if (that.errorCallback) {
                that.errorCallback(ScalablePlayer.ErrorType.PERMISSION, e)
            }
            console.error('wavveplayer-load: Rejected on streaming api')
        })

        if (this.playerType === ScalablePlayer.playerType.INSTANT && contentType === ScalablePlayer.contentType.LIVE) {
          this.metaObj = new MetaObj()
          let userInfo = this.dataInfo.getDefaultParam(contentType, this.playerMode)
          this.apiManager.getMeta(contentType, contentID, this.metaObj, userInfo, this.playerMode).then(function (metaObj) {
            if (ScalablePlayer.isNull(that.player)) { // Already called destructor
              console.log('wavveplayer-load-getMeta: Player is null.')
              return
            }
            that.metaObj = metaObj
            that.player.updateUI(metaObj)
          }, function (e) {
            console.error('wavveplayer-load: Rejected on meta api')
          })
        }
    }

    setLoadedCallback (func) {
        if (ScalablePlayer.isNull(this.player)) {
            console.log('wavveplayer-setLoadedCallback: player is not constructed.')
            return false
        }
        if (typeof func !== 'function') {
            console.log('wavveplayer-setLoadedCallback: Invalid parameter type. (typeof func=' + typeof func + ')')
            return false
        }
        this.player.setLoadedCallback(func)
    }

    unload () {
        if (ScalablePlayer.isNull(this.player)) {
            return false
        }
        this.player.unload()
    }

    unloaded () {
        if (this.unloadedCallback) {
            this.unloadedCallback()
        }
    }

    setUserInfo (userInfo) {
        this.dataInfo.setUserInfo(userInfo)
    }

    setTimeoutCallback (func) {
        if (typeof func !== 'function') {
            console.log('wavveplayer-setTimeoutCallback: Invalid parameter type. (typeof func=' + typeof func + ')')
            return false
        }
        this.unloadedCallback = func
        this.player.setTimeoutCallback(func)
    }

    setErrorCallback (func) {
        if (typeof func !== 'function') {
            console.log('wavveplayer-setErrorCallback: Invalid parameter type. (typeof func=' + typeof func + ')')
            return false
        }
        this.errorCallback = func
        this.player.setErrorCallback(func)
    }

    getProgressRate () {
        if (ScalablePlayer.isNull(this.player)) {
            return false
        }
        return this.player.getProgressRate()
    }

    setInitImage (path) {
        if (ScalablePlayer.isNull(this.player)) {
            return false
        }
        this.player.setInitImage(path)
    }

    setMute (isMute) {
        if (ScalablePlayer.isNull(this.player)) {
            return false
        }
        this.player.setMute(isMute)
    }

    /**
     * private function
     */
    play () {
        this.player.play()
    }

    pause () {
        this.player.pause()
    }

    changeMode (mode) {
        if (ScalablePlayer.isNull(mode)) {
            console.error('wavveplayer-changeMode: Invalid parameter. (mode=' + mode + ')')
            return null
        }
        this.playerMode = mode
        this.player.changeMode(mode)
    }
}
ScalablePlayer.Version = '2.1.26'
ScalablePlayer.playerType = {
    INSTANT: 'i'
}
ScalablePlayer.cloudType = {
    AMAZON: 'a',
    AZURE: 'm'
}
ScalablePlayer.contentType = {
    NONE: 'none',
    LIVE: 'live',
    VOD: 'vod',
    AD: 'ad',
    MOVIE: 'movie',
    QVOD: 'onairvod',
    PROGRAM: 'program',
    BASEBALL_LIVE: 'baseballlive',
    BASEBALL_HIGHLIGHT: 'baseballhighlight'
}
ScalablePlayer.playerMode = {
    INIT: 'i',
    DEFAULT: 'd',
    CUSTOM: 'c',
    CONDENSATION: 'cd',
    POPUP: 'p',
    INSTANT: 'i'
}
ScalablePlayer.ErrorType = {
    PERMISSION: 'p',
    PLAYER_INTERNAL: 'v'
}
ScalablePlayer.isNull = function (item) {
    if (item === null || item === undefined) {
        return true
    }
    if (typeof item === typeof '' && item === '') {
        return true
    }
    return false
}
ScalablePlayer.chromlessPlayerAble = function () {
    let browser = ScalablePlayer.getBrowser()
    console.log(browser)
    let name = browser.name.toLowerCase()
    let version = Number(browser.version)
    version = (isNaN(version) === true) ? -1 : version
    let isAble = true
    switch (name) {
        case 'firefox':
            isAble = (version >= 52)
            break
        case 'safari':
            isAble = (version >= 11)
            break
        case 'chrome':
            isAble = (version >= 52)
            break
        case 'opera':
            isAble = (version >= 15)
            break
        default :
            isAble = (name.indexOf('ie') === -1)
            break
    }
    return isAble
}

ScalablePlayer.getBrowser = function () {
    let ua = navigator.userAgent; let tem; let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || []
        return {
            name: 'IE',
            version: (tem[1] || '')
        }
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/)
        if (tem != null) {
            return {
                name: 'Opera',
                version: tem[1]
            }
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1])
    }

    return {
        name: M[0],
        version: M[1]
    }
}
